module.exports = __webpack_public_path__ + "static/img/20015 (6).71c03c7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20015 (6).webp
// module id = WfTm
// module chunks = 14